import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", {
    class: `grid gap-2 grid-cols-2 sm:grid-cols-${_ctx.headers.length}`
  }, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.headers, (header, index) => {
      return (_openBlock(), _createBlock("div", {
        key: index,
        class: {
				'pl-2': index === 0,
				'hidden sm:block': !['name', 'actions', 'vehicle'].includes(
					header
				),
			}
      }, _toDisplayString(_ctx.toTitleCase(header, '_')), 3))
    }), 128 /* KEYED_FRAGMENT */))
  ], 2))
}